namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    /*
     * options:
     *  columnGenerator: function that returns array of current column definitions
     *  columnVisibilityInitialFilterCreator: initial visibility filter creator as expected on DataTableControl.
     *  columnOrderIds: array of initial ordering for column by column id
     *  visibleColumnIds: array of initial visible columns by column id
     * 
     *  columnMods: array of { id, mods }
     */
    export class ColumnSet {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public _columnGenerator;
        public _columns: DataTableHelpers.Column[];
        public _columnIdToColumnMap: Record<string, DataTableHelpers.Column>;
        public _visibleColumnIdMap;
        public _columnVisibilityInitialFilterCreator;
        public _initialUpdateColumnCompleted;
        public _initialColumnOrderIds;
        public _initialVisibleColumnIds;
        public _initialHiddenColumnIds;
        public _initialColumnMods;
        public _customColumnSettings;


        constructor(options) {
            this.tableControl = options.tableControl;
            this._columnGenerator = options.columnGenerator;

            this._columns = [];
            this._columnIdToColumnMap = {};

            // Maps column id to true if column is visible.
            this._visibleColumnIdMap = {};

            this._columnVisibilityInitialFilterCreator = options.columnVisibilityInitialFilterCreator ? options.columnVisibilityInitialFilterCreator : null;

            this._initialUpdateColumnCompleted = false;

            this._initialColumnOrderIds = options.columnOrderIds ? options.columnOrderIds : null;
            this._initialVisibleColumnIds = options.visibleColumnIds ? options.visibleColumnIds : null;
            this._initialHiddenColumnIds = options.hiddenColumnIds ? options.hiddenColumnIds : null;

            this._initialColumnMods = options.columnMods ? options.columnMods : null;

            this._customColumnSettings = options.customColumnSettings ? options.customColumnSettings : null;
        }


        public getColumnById(id): DataTableHelpers.Column | null {
            if (this._columnIdToColumnMap[id]) {
                var col = this._columnIdToColumnMap[id];
                return col;
            }

            return null;
        }

        public getColumnList(): DataTableHelpers.Column[] {
            var self = this;
            var colList = [];

            $(this._columns).each(function (i, col) {
                colList.push(col);
            });

            return colList;
        }

        public getVisibleColumnIds() {
            var self = this;
            var visibleColumnIds = [];
            //Load from columns only if they are available. Otherwise, load from initial setting.
            if (this._columns.length > 0) {
                $(this._columns).each(function (i, col) {
                    if (self._visibleColumnIdMap[col.id]) {
                        visibleColumnIds.push(col.id);
                    }
                });
                this._initialVisibleColumnIds = visibleColumnIds;
            } else if (this._initialVisibleColumnIds) {
                visibleColumnIds = this._initialVisibleColumnIds;
            }

            return visibleColumnIds;
        }

        public getHiddenColumnIds() {
            var self = this;
            var hiddenColumnIds = [];
            //Load from columns only if they are available. Otherwise, load from initial setting.
            if (this._columns.length > 0) {
                $(this._columns).each(function (i, col) {
                    if (!self._visibleColumnIdMap[col.id]) {
                        hiddenColumnIds.push(col.id);
                    }
                });
                this._initialHiddenColumnIds = hiddenColumnIds;
            } else if (this._initialHiddenColumnIds) {
                hiddenColumnIds = this._initialHiddenColumnIds;
            }

            return hiddenColumnIds;
        }

        public getColumnOrderIds() {
            var columnOrderIds = [];
            //Load from columns only if they are available. Otherwise, load from initial setting.
            if (this._columns.length > 0) {
                $(this._columns).each(function (i, col) {
                    columnOrderIds.push(col.id);
                });
                this._initialColumnOrderIds = columnOrderIds;
            } else if (this._initialColumnOrderIds) {
                columnOrderIds = this._initialColumnOrderIds;
            }

            return columnOrderIds;
        }

        public getVisibleColumnDefinitions() {
            var self = this;
            var colDefList = [];

            var visibleColumnIds = this.getVisibleColumnIds();
            $(visibleColumnIds).each(function (i, colId) {
                var col = self.getColumnById(colId);

                if (!col) {
                  return;
                }

                var colDef = col.definitionToUse;
                colDefList.push(colDef);
            });

            return colDefList;
        }

        public getColumnMods() {
            var modList = [];
            //Load from columns only if they are available. Otherwise, load from initial setting.
            if (this._columns.length > 0) {
                $(this._columns).each(function (i, col: any) {
                    if (col.mods) {
                        modList.push({
                            id: col.id,
                            mods: col.mods
                        });
                    }
                });
                this._initialColumnMods = modList;
            } else if (this._initialColumnMods) {
                modList = this._initialColumnMods;
            }

            return modList;
        }


        public updateColumns() {
            var self = this;

            var columns: DataTableHelpers.Column[] = [];
            var columnIdToColumnMap = {};
            var visibleColumns = [];

            // Save existing column mods.
            var existingColumnMods = this.getColumnMods();

            if (this._columnGenerator) {
                var columnDefinitions = this._columnGenerator();

                $(columnDefinitions).each(function (i, colDef) {
                    var col = new Solovis.Reports.Parts.Tables.DataTableHelpers.Column({
                        columnSet: self,
                        column: colDef
                    });
                    columns.push(col);
                    columnIdToColumnMap[col.id] = col;
                });

                if (this._customColumnSettings) {
                    var customColumnDefinitions = this._getCustomColumnDefinitions();
                    $(customColumnDefinitions).each(function (i, customColDef) {
                        var col = new Solovis.Reports.Parts.Tables.DataTableHelpers.Column({
                            columnSet: self,
                            column: customColDef
                        });
                        columns.push(col);
                        columnIdToColumnMap[col.id] = col;
                    });
                }
            }

            // Determine currently existing and visible columns.
            var existingColumnMap = {};
            var existingColumnOrderIds = [];
            $(this._columns).each(function (i, col) {
                existingColumnMap[col.id] = true;
                existingColumnOrderIds.push(col.id);
            });

            // Restore prior column order.          
            this._restoreColumnOrder(columns, existingColumnOrderIds);

            // Restore visibility.
            var visibleColumnMap = {};
            $(columns).each(function (i, col: any) {
                if (!existingColumnMap[col.id]) {
                    if (!col.hiddenByDefault) {
                        visibleColumnMap[col.id] = true;
                    }
                }
                else {
                    // This column existed previously, so keep prior visibility setting.
                    if (self._visibleColumnIdMap[col.id]) {
                        visibleColumnMap[col.id] = true;
                    }
                }
            });

            this._columns = columns;
            this._columnIdToColumnMap = columnIdToColumnMap;
            this._visibleColumnIdMap = visibleColumnMap;

            if (this._columnVisibilityInitialFilterCreator) {
                var visibilityFilter = this._columnVisibilityInitialFilterCreator.call(this.tableControl);

                // On the very first column creation, we should adjust visible columns on given criteria.
                this.toggleVisibleColumnsWithFilter(visibilityFilter, true /* suppressColumnsChangedEvent */);
                this._columnVisibilityInitialFilterCreator = null;
            }

            // Restore column order from persisted settings on initial load.
            if (!this._initialUpdateColumnCompleted && this._initialColumnOrderIds) {
                this._restoreColumnOrder(this._columns, this._initialColumnOrderIds);
            }

            // Restore visibility on initial load.
            if (!this._initialUpdateColumnCompleted && (this._initialVisibleColumnIds || this._initialHiddenColumnIds)) {
                var initialVisibleColumnIdMap = {};
                var initialHiddenColumnIdMap = {};

                $(this._initialVisibleColumnIds).each(function (i, colId: any) {
                    if (columnIdToColumnMap[colId]) {
                        initialVisibleColumnIdMap[colId] = true;
                    }
                });

                $(this._initialHiddenColumnIds).each(function (i, colId: any) {
                    if (columnIdToColumnMap[colId]) {
                        initialHiddenColumnIdMap[colId] = true;
                    }
                });

                // We will modify the visible column id map by making previously visible columns visible again
                //   and hiding columns that were previously hidden.            
                $(this._columns).each(function (i, col) {
                    if (self._visibleColumnIdMap[col.id]) {
                        if (initialHiddenColumnIdMap[col.id]) {
                            delete self._visibleColumnIdMap[col.id];
                        }
                    }
                    else {
                        if (initialVisibleColumnIdMap[col.id]) {
                            self._visibleColumnIdMap[col.id] = true;
                        }
                    }
                });
            }

            var columnModsToAppy = !this._initialUpdateColumnCompleted && this._initialColumnMods ?
                this._initialColumnMods
                : existingColumnMods;
            if (columnModsToAppy) {
                $(columnModsToAppy).each(function (i, colMods: any) {
                    if (columnIdToColumnMap[colMods.id]) {
                        var col = columnIdToColumnMap[colMods.id];
                        col.updateMods(colMods.mods, true /* suppressColumnChangeEvent */);
                    }
                });
            }

            if (!this._initialUpdateColumnCompleted) {
                this._initialUpdateColumnCompleted = true;
            }

            this.notifyColumnsChanged({
                columnsUpdated: true
            });
        }


        public changeColumnOrderWithIdList(columnOrderIdList, suppressColumnsChangedEvent) {
            this._restoreColumnOrder(this._columns, columnOrderIdList);

            if (!suppressColumnsChangedEvent) {
                this.notifyColumnsChanged({
                    orderChanged: true
                });
            }
        }

        /**
         * Reorder and change visibility in one step, so that we just get one event triggered.
         * @param columnOrderIdList
         * @param isVisibleFn
         */
        public reorderColumnsAndToggleVisibility(columnOrderIdList, isVisibleFn) {           
            this.changeColumnOrderWithIdList(columnOrderIdList, true);
            this.toggleVisibleColumnsWithFilter(isVisibleFn, true);

            this.notifyColumnsChanged({
                orderChanged: true,
                visibilityChanged: true
            });
        };


        /**
         * Do an in-place sort of columns to preserve order seen in priorColumnOrderIds.
         * @param columns
         * @param priorColumnOrderIds
         */
        public _restoreColumnOrder(columns, priorColumnOrderIds) {
            var columnIdToColumnMap: any = {};
            var currentColumnOrderMap: any = {};

            $(columns).each(function (i, col: any) {
                columnIdToColumnMap[col.id] = col;
                currentColumnOrderMap[col.id] = i;
            });

            var persistedColumnOrderMap: any = {};
            $(priorColumnOrderIds).each(function (i, colId: any) {
                persistedColumnOrderMap[colId] = i;
            });

            // Build up list of newly added columns.
            var newColumnList = [];
            $(columns).each(function (i, col) {
                if (typeof persistedColumnOrderMap[col.id] == "undefined") {
                    newColumnList.push(col);
                }
            });

            // Place all previous columns in their original order
            var newlyOrderedColumns: any = [];

            $(priorColumnOrderIds).each(function (i, colId: any) {
                var col = columnIdToColumnMap[colId];
                if (col) {
                    newlyOrderedColumns.push(col);
                }
            });

            // For each of the new columns, we should place them after the column that they appear after in the existing list.
            $(newColumnList).each(function (i, newCol) {
                var currentIndex = currentColumnOrderMap[newCol.id];
                var previousCol = null;
                if (currentIndex > 0) {
                    previousCol = columns[currentIndex - 1];
                }

                var newColIndex = 0;
                if (previousCol) {
                    var previousColIndex = _.findIndex(newlyOrderedColumns, function (col: any) { return col.id == previousCol.id });
                    if (previousColIndex < 0) {
                        newColIndex = newlyOrderedColumns.length;
                    }
                    else {
                        newColIndex = previousColIndex + 1;
                    }
                }

                newlyOrderedColumns.splice(newColIndex, 0, newCol);
            });

            // Copy newly ordered columns back into the original array.
            $(newlyOrderedColumns).each(function (i, col) {
                columns[i] = col;
            });
        }

        /**
         * isVisibleFn(col, currentlyVisible) will be called for every column to determine if it should be visible.
         * @param isVisibleFn
         * @param suppressColumnsChangedEvent
         */
        public toggleVisibleColumnsWithFilter(isVisibleFn, suppressColumnsChangedEvent) {            
            var self = this;

            var newVisibleColumnIdMap = [];

            $(this._columns).each(function (i, col) {
                var currentlyVisible = self._visibleColumnIdMap[col.id] ? true : false;
                if (isVisibleFn(col, currentlyVisible)) {
                    newVisibleColumnIdMap[col.id] = true;
                }
            });

            this._visibleColumnIdMap = newVisibleColumnIdMap;

            if (!suppressColumnsChangedEvent) {
                this.notifyColumnsChanged({
                    visibilityChanged: true
                });
            }
        }


        public notifyColumnsChanged(data) {
            // NOTE: This is called both from ColumnSet directly and by Column objects.
            $(this).trigger("columnsChanged", data);
        }


        private static _getCustomTagData(tag: InvData.Models.Tag) {
            let tagData = {
                id: tag.id,
                label: tag.label,
                code: tag.code,
                level: tag.level,
                tagOrder: tag.tagOrder,
                tagSetId: tag.tagSet.id,
                parentTagId: tag.parentTagId
            };

            return tagData;
        }

        public _getCustomColumnDefinitions() {
            var self = this;

            var colDefList = [];

            if (this._customColumnSettings) {
                $(this._customColumnSettings).each(function (i, colSettings: any) {
                    if (!colSettings.customId) {
                        console.log("ColumnSet: ERROR: colSettings is missing customId");
                    }
                    else {
                        var colDef: any = {};

                        colDef.id = "custom_" + colSettings.customId;

                        if (colSettings.label) {
                            colDef.label = colSettings.label;
                        }
                        else {
                            colDef.label = colSettings.customId;
                        }

                        if (colSettings.dataType) {
                            colDef.dataType = colSettings.dataType;
                        }

                        if (colSettings.formula) {
                            try {
                                let tableParameters = self.tableControl.parameters;
                                let formulaTree = jsep(colSettings.formula);                                

                                colDef.field = function (row) {
                                    let cellValueGetter = (columnId) => {                                        
                                        if (row._groupTotals) {
                                            let rowGroupTotal = row._groupTotals[columnId];
                                            if (Solovis.isNotNull(rowGroupTotal)) {
                                                return rowGroupTotal;
                                            }
                                        }

                                        let colForId = self.getColumnById(columnId);
                                        if (colForId) {
                                            let rowToUse = row;
                                            if (row && row._backingRow) {
                                                rowToUse = row._backingRow;
                                            }

                                            let cellValue = self.tableControl._getColumnValueForRow(colForId, rowToUse);
                                            return cellValue;
                                        }
                                        return null;
                                    };

                                    let customFunctions = {
                                        debugRowObject: function () {
                                            return row;
                                        },

                                        column: cellValueGetter,

                                        columnTag: function (columnId) {
                                            var colForId = self.getColumnById(columnId);
                                            if (colForId) {
                                                if (colForId.dataType === "tagId") {
                                                    var cellValue = cellValueGetter(columnId);
                                                    if (cellValue) {
                                                        let tagSet = self.tableControl.modelEnvironment.tagSets.tryGetById(colForId.definitionToUse.tagSetId);
                                                        if (tagSet) {
                                                            let tag = tagSet.tryGetTagById(cellValue);
                                                            if (tag) {
                                                                let tagData = ColumnSet._getCustomTagData(tag);
                                                                return tagData;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            return null;
                                        },

                                        tagAtLevel: function (tagData, level) {
                                            if (tagData) {
                                                let tagSet = self.tableControl.modelEnvironment.tagSets.tryGetById(tagData.tagSetId);
                                                if (tagSet) {
                                                    let tag = tagSet.tryGetTagById(tagData.id);
                                                    if (tag) {
                                                        let tagAtLevel = tag.getLevel(level);
                                                        if (tagAtLevel) {
                                                            let tagAtLevelData = ColumnSet._getCustomTagData(tagAtLevel);
                                                            return tagAtLevelData;
                                                        }
                                                    }
                                                }
                                            }

                                            return null;
                                        },

                                        tagAtLowestLevel: function (tagData, level) {
                                            if (tagData) {
                                                let tagSet = self.tableControl.modelEnvironment.tagSets.tryGetById(tagData.tagSetId);
                                                if (tagSet) {
                                                    let tag = tagSet.tryGetTagById(tagData.id);
                                                    if (tag) {
                                                        let tagAtLevel = tag.getLowestLevel(level);
                                                        if (tagAtLevel) {
                                                            let tagAtLevelData = ColumnSet._getCustomTagData(tagAtLevel);
                                                            return tagAtLevelData;
                                                        }
                                                    }
                                                }
                                            }

                                            return null;
                                        }
                                    };

                                    // Add custom settings.
                                    if (self.tableControl._tableSettingsToUse && self.tableControl._tableSettingsToUse.customFunctions) {
                                        let extraCustomFunctions = self.tableControl._tableSettingsToUse.customFunctions(self.tableControl);
                                        for (let functionName in extraCustomFunctions) {
                                            customFunctions[functionName] = extraCustomFunctions[functionName];
                                        }
                                    }                                    

                                    let value = Solovis.Reports.Parameters.ParameterTransforms.transform(
                                        null,
                                        {
                                            transformTree: formulaTree,

                                            parameterValueGetter: function (paramName) {
                                                if (tableParameters)
                                                    return tableParameters[paramName];

                                                return null;
                                            },

                                            customFunctions: customFunctions
                                        });

                                    return value;
                                };
                            }
                            catch (error) {
                                console.log("ColumnSet: ERROR: Unable to create field getter for: " + colDef.id);
                                console.log("ColumnSet: ERROR: Unable to create field getter for formula: " + colSettings.formula);
                            }
                        }
                        else {
                            colDef.field = function (row) {
                                return null;
                            };
                        }

                        colDefList.push(colDef);
                    }
                });
            }

            return colDefList;
        }


        public getSerializableCustomColumnSettings() {
            var settings = null;
            if (!_.isEmpty(this._customColumnSettings)) {
                settings = Solovis.deepCopy(this._customColumnSettings);
            }

            return settings;
        }

        public hasCustomColumnWithCustomId(customId) {
            if (!_.isEmpty(this._customColumnSettings)) {
                var customColumn = _.find(this._customColumnSettings, function (i: any) { return i.customId === customId; });
                return (customColumn != null) ? true : false;
            }

            return false;
        }

        public updateCustomColumnSettings(newColumnSettings, suppressColumnsChangedEvent?) {
            if (!newColumnSettings.customId) {
                throw "newColumnSettings does not include customId";
            }

            var newCustomColumnSettingsList = [];
            var found = false;

            $(this._customColumnSettings).each(function (i, colSettings: any) {
                if (colSettings.customId === newColumnSettings.customId) {
                    found = true;
                    newCustomColumnSettingsList.push(newColumnSettings);
                }
                else {
                    newCustomColumnSettingsList.push(colSettings);
                }
            });

            if (!found) {
                newCustomColumnSettingsList.push(newColumnSettings);
            }

            this._customColumnSettings = newCustomColumnSettingsList;

            this.updateColumns();

            if (!suppressColumnsChangedEvent) {
                this.notifyColumnsChanged({
                    customColumnsUpdated: true
                });
            }
        }

        public removeCustomColumnSettingsForCustomId(customIdToRemove, suppressColumnsChangedEvent?) {
            var newCustomColumnSettingsList = [];

            $(this._customColumnSettings).each(function (i, colSettings: any) {
                if (colSettings.customId !== customIdToRemove) {
                    newCustomColumnSettingsList.push(colSettings);
                }
            });

            this._customColumnSettings = newCustomColumnSettingsList;

            this.updateColumns();

            if (!suppressColumnsChangedEvent) {
                this.notifyColumnsChanged({
                    customColumnsUpdated: true
                });
            }
        }
    }

}
